<template>
    <div>
      <vs-alert style="height: 70px;" v-if="!AdminBodega || userBodegaNormal">
        <p>
          Los documentos de actas que no esten enviados a <b>PERSEO</b> <b> bodega</b> no va a poder visualizar
        </p>
      </vs-alert>
      <!--boton para recargar-->
      <vs-button v-if="filtro != 3" class="mt-2" color="primary" type="filled" icon="refresh" @click="getGuias(false, filtro)"></vs-button>
      <br>
      <!-- Filtro de Fechas - Solo visible en filtro de Entregados -->
      <div v-if="filtro == 3" class="vx-row mt-3 mb-3" style="background: #f5f5f5; padding: 15px; border-radius: 5px;">
        <div class="vx-col w-full md:w-1/4 px-2">
          <label class="vs-input--label font-semibold">Fecha Inicio:</label>
          <vs-input type="date" v-model="fechaInicio" class="w-full" />
        </div>
        <div class="vx-col w-full md:w-1/4 px-2">
          <label class="vs-input--label font-semibold">Fecha Fin:</label>
          <vs-input type="date" v-model="fechaFin" class="w-full" />
        </div>
        <div class="vx-col w-full md:w-1/4 px-2" style="display: flex; align-items: flex-end;">
          <vs-button @click="filtrarPorFechas()" color="success" type="filled" icon-pack="feather" icon="icon-filter" class="w-full">
            Filtrar por Fechas
          </vs-button>
        </div>
        <div class="vx-col w-full md:w-1/4 px-2" style="display: flex; align-items: flex-end;">
          <vs-button @click="limpiarFiltroFechas()" color="warning" type="border" icon-pack="feather" icon="icon-x" class="w-full">
            Limpiar Filtro
          </vs-button>
        </div>
      </div>
        <ul class="flex" style="flex-wrap:center;flex-wrap: wrap;">
            <li v-if="userAdmin == true || usuario.id_group == 27 " class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="0"><span style="font-weight:bold;">{{sumaPendientes}}</span> Pendientes</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="1"><span style="font-weight:bold;">{{ SumaAprobados }}</span> Aprobados</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="2"><span style="font-weight:bold;">{{ SumaAprobadosPendientes }}</span> Aprobados con pendientes</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="4"><span style="font-weight:bold;">{{ SumaAnulados }}</span> Anulados por facturación </vs-radio>
            </li>
            <li class="m-2" v-if="!AdminBodega || userBodegaNormal">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="5"><span style="font-weight:bold;">{{ SumaSinEnviarPerseo }}</span> Sin enviar a PERSEO </vs-radio>
            </li>
            <li class="m-2" v-if="!AdminBodega || userBodegaNormal">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="6"><span style="font-weight:bold;">{{ SumaEnviadosPerseo }}</span> Enviados a PERSEO </vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="3"><span style="font-weight:bold;">{{ SumaEntregados }}</span> Entregados / Despachados por bodega </vs-radio>
            </li>
            <li v-if="(usuario.id_group  == 22 || usuario.id_group == 23 || usuario.id_group == 27) && filtro==3" class="m-2">
                <vs-input  icon-after="true" style="width: 250px;"  icon="search" placeholder="Buscar Acta" v-model="busquedaxcodigo" @keyup.enter="filtrarPedidos()" />
            </li>
        </ul>
        <vs-table search :data="tmpPedidos" pagination max-items="10">
            <template slot="header">
                <vs-chip>Cantidad: {{ tmpPedidos.length }}</vs-chip>
                <!-- <p class="btn_lg font-semibold ml-2">Pedidos de guias </p> -->
            </template>
            <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th sort-key="asesor">Asesor / Responsables</vs-th>
                <vs-th style="width: 140px;" sort-key="fecha_envio">Fechas</vs-th>
                <vs-th style="width: 80px;" sort-key="asesor">Cant. guias</vs-th>
                <vs-th sort-key="asesor">Estado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td> {{ tr.id_pedido }} </vs-td>
                    <vs-td>
                        <p class="font-bold">Responsable:</p>
                        <span>{{ tr.responsable }} </span>
                        <p class="font-bold">Cédula:</p>
                        <span>{{ tr.cedula }} </span>
                        <p v-if="filtro > 0" class="font-bold">Empresa:</p>
                        <span v-if="filtro > 0" >{{tr.empresa}}</span>
                        <p class="font-bold">Período solicitud:</p>
                        <vs-chip color="primary">{{ tr.periodo }} </vs-chip>
                        <div v-if="tr.facturacion_vee == 0">
                            <br>
                            <br>
                           <p class="text-danger font-bold">Facturador no puede ver</p>
                        </div>
                        <br><br>
                        <vs-chip v-if="tr.guias_version_perseo == 1">Modulo con perseo</vs-chip>
                    </vs-td>
                    <vs-td>
                        <p class="font-bold">Fecha de envio:</p>
                        <span>{{ tr.fecha_envio.substring(0,10) }} </span>
                        <p class="font-bold mt-2">Fecha de creación:</p>
                        <span>{{ tr.created_at ? tr.created_at.substring(0,10) : 'N/A' }} </span>
                    </vs-td>
                    <vs-td>
                        {{ tr.total_unidades_guias }}
                    </vs-td>
                    <vs-td>
                        <div v-if="tr.estado == 2">
                            <vs-chip class="text-danger font-bold">Anulado</vs-chip>
                            <br><br>
                            <b>Anulado por:</b>
                            <p>{{ tr.usuario_anulado }}</p>
                            <b>Mensaje anulado:</b>
                            <p>{{ tr.message_anulado }}</p>
                            <br>
                        </div>
                        <p v-if="tr.observacion != null">
                            <vx-tooltip style="display: inline-block;" text="Ver Observación asesor" position="top" color="primary">
                                <vs-button  class="modal-default-button p-2" @click="pedido=tr;popupObservacion=true;" size="small" color="dark" type="filled" icon-pack="feather" icon="icon-message-circle">Ver observación </vs-button>
                            </vx-tooltip>
                        </p>
                        <span v-if="tr.estado_entrega == 0"><b>Pedido:</b><span class="ml-1">Creado</span></span>
                        <span color="primary" v-if="tr.estado_entrega == 1"><b>Pedido:</b><span class="ml-1">Aprobado por facturación</span></span>
                        <span color="success" v-if="tr.estado_entrega == 2"><b>Pedido:</b><span class="ml-1">Entregado por bodega</span></span><br>
                        <div v-if="tr.ven_codigo != null">
                            <p><b>Acta:</b> {{ tr.ven_codigo }}</p>
                        </div>
                        <b v-if="tr.estado_entrega > 0 && tr.guias_version_perseo == 0">Fecha aprobacion:</b>
                        <p v-if="tr.estado_entrega > 0 && tr.guias_version_perseo == 0">{{ tr.fecha_aprobado_facturacion }}</p>
                        <b v-if="tr.estado_entrega > 1 && tr.guias_version_perseo == 0">Fecha entrega bodega:</b>
                        <p v-if="tr.estado_entrega > 1 && tr.guias_version_perseo == 0">{{ tr.fecha_entrega_bodega }}</p>
                        <div v-if="tr.estado_entrega == '3'">
                          <p class="text-danger font-bold">Actas con pendientes</p>
                        </div>

                        <!-- Enviadas a PERSEO -->
                        <!-- <div v-if="verificarTodosEnviadosPerseo(tr)">
                          <p class="text-success font-bold">Enviadas a PERSEO</p>
                        </div> -->

                        <!-- Pendientes versión PERSEO -->
                        <div v-if="tr.pendientes.length > 0 && tr.guias_version_perseo == 1">
                          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                            <b>Documentos Actas:</b>
                            <vs-button
                              @click="pedido=tr; tabInicial='Documentos de venta'; popupGenerarDocumento=true;"
                              size="small"
                              color="primary"
                              type="relief"
                              icon-pack="feather"
                              icon="icon-file-text"
                            >
                              Ver Documentos
                            </vs-button>
                          </div>
                          <table style="width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 12px;">
                            <thead>
                              <tr style="background-color: #f5f5f5;">
                                <th style="border: 1px solid #ddd; padding: 6px; text-align: left;">Documento</th>
                                <th style="border: 1px solid #ddd; padding: 6px; text-align: center;">Enviado a PERSEO</th>
                                <th style="border: 1px solid #ddd; padding: 6px; text-align: center;">Fecha de Despacho</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(p, index) in tr.pendientes" :key="index">
                                <td style="border: 1px solid #ddd; padding: 6px;" >
                                  <p class="cursor-pointer" v-if="tr.guias_version_perseo == 1" @click="abrirDocumentoPerseo(p, tr)"
                                     style="text-decoration: underline; color: #007BFF; margin: 0;">
                                    {{ p.ven_codigo }}
                                  </p>
                                  <p class="cursor-pointer" v-if="tr.guias_version_perseo == 0" @click="pedido=tr;ObjectPedidoHijo=p;f_mostrarDocumentoPendiente()"
                                     style="text-decoration: underline; color: #007BFF; margin: 0;">
                                    {{ p.ven_codigo }}
                                  </p>
                                  <b>Fecha de Creación:</b>
                                  <p>{{ p.ven_fecha }}</p>
                                  <p><b>Estado: </b>
                                    <span v-if="p.est_ven_codigo == 2" style="color: #ff9800; font-weight: bold;">Pendiente de despacho</span>
                                    <span v-else-if="p.est_ven_codigo == 1" style="color: #28a745; font-weight: bold;">Despachado</span>
                                    <span v-else-if="p.est_ven_codigo == 3" style="color: red; font-weight: bold;">Anulado</span>
                                    <span v-else>{{ p.est_ven_codigo }}</span>
                                  </p>
                                </td>
                                <td style="border: 1px solid #ddd; padding: 6px; text-align: center;">
                                  <span v-if="p.estadoPerseo == 1" style="color: #28a745; font-weight: bold;">Sí</span>
                                  <span v-else style="color: #dc3545; font-weight: bold;">No</span>
                                  <div v-if="p.estadoPerseo == 1">
                                    <p><b>Pedido Perseo:</b> {{ p.pedido_codigo }}</p>
                                  </div>
                                  <div v-if="p.observacion_anula_envio_perseo" style="margin-top: 6px; padding: 6px; background: #fff3cd; border-radius: 4px; text-align: left;">
                                    <p style="font-size: 11px;"><b>Pedido anterior removido:</b> {{ p.observacion_anula_envio_perseo }}</p>
                                  </div>
                                </td>
                                <td style="border: 1px solid #ddd; padding: 6px; text-align: center;">
                                  {{ p.fecha_proceso_despacho }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- Pendientes versión antigua -->
                        <div v-if="tr.pendientes.length > 0 && tr.guias_version_perseo == 0">
                          <div v-for="(p,index) in tr.pendientes" :key="index">
                            <p class="cursor-pointer my-2" @click="pedido=tr;ObjectPedidoHijo=p;f_mostrarDocumentoPendiente()"
                               style="text-decoration: underline; color: #007BFF; font-size: 18px;">
                              {{ p.ven_codigo }}
                            </p>
                          </div>
                        </div>
                    </vs-td>
                    <vs-td align="center">
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                            <vs-dropdown-menu style="width: 250px;" class="cursor">
                                <!--Generar  ACTA-->
                                <vs-dropdown-item v-if="groupFacturador && tr.guias_version_perseo == 1">
                                     <vs-button class="w-full" color="dark"  icon-pack="feather" icon="icon-check" type="line" @click="popupGenerarDocumento=true;pedido = tr;tabInicial='Resumen';">Módulo Perseo</vs-button>
                                </vs-dropdown-item>
                                 <!--APROBAR ACTA-->
                                <vs-dropdown-item v-if="groupFacturador && tr.ven_codigo == null && tr.estado == 1  && tr.guias_version_perseo == 0">
                                    <vx-tooltip style="display: inline-block;" text="AL PRESIONAR SE ENVIARA AL SISTEMA DE FACTURACION" position="top" color="primary">
                                     <vs-button class="w-full" color="dark"  icon-pack="feather" icon="icon-check" type="line" @click="verResumen =false;pedido = tr;tipoProceso=0;openConfirmEmpresa(0)">Aprobar solicitud</vs-button>
                                    </vx-tooltip>
                                </vs-dropdown-item>
                                <!--APROBAR PENDIENTES-->
                                <vs-dropdown-item v-if="groupFacturador && tr.estado_entrega == '3' && tr.estado == 1 && tr.guias_version_perseo == 0">
                                    <vs-button class="w-full" color="danger"  icon-pack="feather" icon="icon-check" type="line" @click="verResumen =false;pedido = tr;tipoProceso=0;openConfirmEmpresa(1)">Aprobar pendientes</vs-button>
                                </vs-dropdown-item>
                                <!--IMPRIMIR ACTA FACTURACION-->
                                <vs-dropdown-item v-if="( userAdmin == true ) && tr.ven_codigo != null && tr.guias_version_perseo == 0">
                                    <vs-button class="w-full" color="#3541D3" icon-pack="feather" icon="icon-printer" type="line" @click="pedido = tr;ImprimirActa(0)">Imprimir acta(f)</vs-button>
                                </vs-dropdown-item>
                                <!--IMPRIMIR ACTA BODEGA-->
                                <vs-dropdown-item v-if="( usuario.id_group == 1  || usuario.id_group == 27 ) && tr.ven_codigo != null && (filtro == 1 || filtro == 2 || filtro == 3) && tr.guias_version_perseo == 0">
                                    <vs-button class="w-full" color="#3541D3" icon-pack="feather" icon="icon-printer" type="line" @click="pedido = tr;ImprimirActa(1)">Imprimir acta(b)</vs-button>
                                </vs-dropdown-item>
                                <!--RESUMEN-->
                                <vs-dropdown-item v-if="tr.guias_version_perseo == 0">
                                    <vs-button class="w-full"  icon="visibility" type="line" @click="verResumen =true;pedido = tr;tipoProceso=0;openConfirmEmpresa()">Resumen</vs-button>
                                </vs-dropdown-item>
                                <!--ANULAR PEDIDO-->
                                <vs-dropdown-item v-if="groupFacturador && tr.estado == 1 && (tr.estado_entrega == 1 || tr.estado_entrega == 3 ) && tr.guias_version_perseo == 0">
                                    <vs-button class="w-full" color="danger" type="line" @click="pedido = tr;popupConfirmAnular=true;"><i class="fa-solid fa-delete-left"></i> Anular guia aprobada</vs-button>
                                </vs-dropdown-item>
                                <!--ENTREGAR GUIAS AL ASESOR(bodega)-->
                                <vs-dropdown-item v-if="(usuario.id_group == 17 || usuario.id_group == 27 || usuario.id_group == 1) && (tr.estado_entrega == 1) && tr.estado == 1">
                                    <!-- <vx-tooltip style="display: inline-block;" text="MARCAR COMO GUIAS ENTREGADAS AL ASESOR(BODEGA)" position="top" color="primary"> -->
                                        <vs-button class="w-full"  icon-pack="feather" color="dark" icon="icon-book" type="line" @click="pedido = tr;openConfirm(tr);">Entregar guias</vs-button>
                                    <!-- </vx-tooltip> -->
                                </vs-dropdown-item>
                                <!--REPORTE GUIA-->
                                <vs-dropdown-item v-if="usuario.id_group != 11 && tr.guias_version_perseo == 0">
                                    <vs-button class="w-full"  icon-pack="feather" icon="icon-file" @click="pedido = tr;getReporteGuia(tr);" color="success" type="line">Reporte guia</vs-button>
                                </vs-dropdown-item>
                                <!--ELIMINAR PEDIDO-->
                                <vs-dropdown-item v-if="tr.estado_entrega == 0 && tr.estado == 1">
                                    <vs-button class="w-full"  color="danger" type="line" @click="confirma_delete_pedido(tr)">Eliminar pedido</vs-button>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!--IMPRIMIR GUIA-->
        <vs-popup fullscreen v-if="mostrarReporteG" title="Reporte Guia" :active.sync="mostrarReporteG">
            <exportGuiasVue :ObjectPedido="pedido" :id_periodo="pedido.id_periodo" :id_pedido="pedido.id_pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA FACTURADOR - ASESOR-->
        <vs-popup fullscreen v-if="mostrarImprimirActa" title="Acta" :active.sync="mostrarImprimirActa">
            <exportActaGuiasVue  v-if="mostrarImprimirActa" :pedido="pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA BODEGA - ASESOR-->
        <vs-popup fullscreen v-if="mostrarImprimirActaBodega" title="Acta" :active.sync="mostrarImprimirActaBodega">
            <exportActaGuiasBodegaVue v-if="mostrarImprimirActaBodega" :pedido="pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA BODEGA -PENDIENTES-->
        <vs-popup fullscreen v-if="mostrarImprimirActaBodegaPendientes" title="Acta" :active.sync="mostrarImprimirActaBodegaPendientes">
          <div v-if="mostrarImprimirActaBodegaPendientes">
            <exportActaGuiasBodegaPendientesVue :pedido="pedido" :ObjectPedidoHijo="ObjectPedidoHijo" @change="changeHandle"/>
          </div>
        </vs-popup>
        <!--IMPRIMIR DOCUMENTO PERSEO-->
        <vs-popup
          fullscreen
          :active.sync="popupDocumentoPerseo"
          v-if="popupDocumentoPerseo"
          title="Documento de Venta"
        >
          <GuiasPrintDocumentoVenta
            v-if="popupDocumentoPerseo"
            :objectedDocumentoVenta="facturaDocumentoPerseo"
          />
        </vs-popup>
        <!--MODAL CARGAR-->
        <vs-popup class="holamundo" title="Cargando" :active.sync="popupCarga">
            <p class="text-warning text-3xl bg-dark"><i class="fa-solid fa-cloud"></i> <b class="ml-2">Espere mientras se descarga el archivo</b></p>
            <img class="mt-2" style="margin-left: 35px;" src="https://cdn-icons-png.flaticon.com/512/4578/4578845.png" />
        </vs-popup>
        <!--MODAL DETALLE DE LIBROS-->
        <vs-popup title="Detalle de libros" fullscreen :active.sync="modalLibros">
            <vs-table max-items="100" search pagination :data="arregloLibros">
                <template slot="header">
                    <div class="row">
                        <div class="col-12">Total Libros: <b>{{totalLibros}}</b></div>
                        <div class="col-12">Items: <b>{{arregloLibros.length}}</b></div>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th>Libro</vs-th>
                    <vs-th>Cant. unidades</vs-th>
                    <vs-th>Precio unitario</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{data[indextr].nombrelibro}}<br>
                        </vs-td>
                        <vs-td>
                            {{data[indextr].valor}}<br>
                        </vs-td>
                        <vs-td>
                            {{tr.precio}}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vs-popup>
        <!--MODAL CONFIRMAR APROBAR-->
        <vs-popup class="popupPadre" fullscreen title="Generar Actas" :active.sync="popupGenerarDocumento" @close="recargarGuias">
          <div v-if="popupGenerarDocumento">
            <ScreenGuiasFacturador :ObjectSelected="pedido" :mixinIdInicioFormatoNewData="mixinIdInicioFormatoNewData" :initialTab="tabInicial"/>
          </div>
        </vs-popup>
        <!--MODAL PARA VER OBSERVACION DEL FACTURADOR-->
        <vs-popup classContent="popup-example" title="Ver comentario Asesor" :active.sync="popupObservacion">
            <p class="font-bold text-warning text-2xl">Comentario Asesor:</p>
            <vs-divider style="margin-top: -2px;"></vs-divider>
            <p class="">{{ pedido.observacion }}</p>
        </vs-popup>
        <!--MODADL PARA MOSTRAR LA EMPRESA -->
        <vs-popup classContent="popup-example" title="Empresa" :active.sync="popupMostrarEmpresa" @close="popupMostrarEmpresa = false;empresa=null;">
            <p class="font-bold text-warning text-2xl">Seleccione la Empresa:</p>
            <v-select :disabled="pedido.estado_entrega > 0" :options="arrayEmpresas" :reduce="arrayEmpresas => arrayEmpresas" label="nombre" class="w-full" v-model="empresa" />
            <br>
            <div class="flex justify-center mt-5">
              <vs-button icon="save" v-if="empresa" class="mr-3" @click="verStock">Seleccionar</vs-button>
              <vs-button color="warning" class="ml-2" @click="popupMostrarEmpresa = false;empresa=null;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
            </div>
            <br><br><br>
        </vs-popup>
         <!--MODAL CONFIRMAR APROBAR-->
        <vs-popup class="holamundo" fullscreen title="Stock de guias" :active.sync="popupConfirmAprobar">
          <div v-if="popupConfirmAprobar">
            <p> <b>Empresa:</b> {{ arrayEmpresas.find(p => p.id == empresa.id).nombre }} <br></p>
            <p v-if="verResumen == false && pedido.estado_entrega != '3'" class="font-bold text-warning text-2xl text-center">Está seguro de aprobar la solicitud de guias?</p>
            <p v-if="verResumen == false && pedido.estado_entrega == '3'" class="font-bold text-warning text-2xl text-center">Aprobacion de guias pendientes</p>
            <GuiasStockVue v-if="popupConfirmAprobar" :arregloStock="arregloStock" :ObjectedSelected="pedido" :verResumen="verResumen" @changeAprobar="changeAprobar" @changeAprobarPendientes="changeAprobarPendientes"/>
            <div v-if="verResumen == false && pedido.estado_entrega != '3'">
              <vs-divider></vs-divider>
              <div v-if="NohayStock && ifAprobarSinStock == '0'">
                <vs-alert color="danger"><p class="text-center">No hay stock no se puede aprobar</p></vs-alert>
              </div>
              <div v-else-if="ifAprobarSinStock == '1'">
                <vs-alert color="warning"><p class="text-center">Aprobar sin stock</p></vs-alert>
                <div class="flex justify-center mt-4">
                  <vs-button color="primary" @click="enviarGuiasBDMilton();" type="border" icon="save">Si deseo aprobar</vs-button>
                  <vs-button color="warning" class="ml-2" @click="popupConfirmAprobar = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
                </div>
              </div>
              <div v-else>
                <div class="flex justify-center">
                  <vs-button color="primary" @click="enviarGuiasBDMilton();" type="border" icon="save">Si deseo aprobar</vs-button>
                  <vs-button color="warning" class="ml-2" @click="popupConfirmAprobar = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </div>
          <br><br>
        </vs-popup>
        <!--MODAL CONFIRMAR ANULACION-->
        <vs-popup class="holamundo" title="Anular pedido aprobado" :active.sync="popupConfirmAnular">
          <div v-if="popupConfirmAnular">
            <b>Documento:</b>
            <p>{{ pedido.ven_codigo }}</p>
            <p class="font-semibold mt-5 text-danger">Esta seguro de anular esta solicitud de guias. al hacerlo regresara el stock a bodega lo aprobado?</p>
            <vs-divider></vs-divider>
            <div>
                <p><b>Mensaje:</b></p>
                <vs-input v-model="message_anulado" placeholder="Escribe un mensaje para el usuario que anuló el pedido" type="textarea" rows="3" class="w-full"></vs-input>
            </div>
            <div class="flex justify-center mt-5">
                <vs-button color="danger" @click="anularPedido" type="border" icon="save">Si deseo anular</vs-button>
                <vs-button color="warning" class="ml-5" @click="popupConfirmAnular = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
            </div>
          </div>
        </vs-popup>
    </div>
    </template>
    <script>
    import {
      mapState
    } from "vuex";
    import exportGuiasVue from '../../../../temporadas/components/exportGuias.vue';
    import exportActaGuiasVue from '../../../../temporadas/components/exportActaGuias.vue';
    import exportActaGuiasBodegaVue from '../../../../temporadas/components/exportActaGuiasBodega.vue';
    import vSelect from 'vue-select'
    import Generalmix from "../../../../../mixins/Generalmix";
    const exportActaGuiasBodegaPendientesVue = () => import('../../../../temporadas/components/Pedidos/exportActaGuiasBodegaPendientes.vue')
    const ScreenGuiasFacturador = () => import('./ScreenGuiasFacturador.vue')
    const GuiasPrintDocumentoVenta = () => import('./GuiasPrintDocumentoVenta.vue')
    import GuiasStockVue from '../GuiasStock.vue';
    export default {
      mixins: [Generalmix],
      components: {
        exportGuiasVue,
        exportActaGuiasVue,
        exportActaGuiasBodegaVue,
        exportActaGuiasBodegaPendientesVue,
        ScreenGuiasFacturador,
        GuiasPrintDocumentoVenta,
        vSelect,
        GuiasStockVue
      },
        data() {
          return {
            usuario: [],
            tmpPedidos: [],
            pedido: {},
            id_pedido: 0,
            popupCarga: false,
            mostrarReporteG: false,
            mostrarImprimirActa:false,
            mostrarImprimirActaBodega:false,
            mostrarImprimirActaBodegaPendientes:false,
            pedidoGuiaEliminar: '',
            filtro: 0,
            arregloLibros: [],
            arregloStock:[],
            modalLibros: false,
            popupGenerarDocumento:false,
            verResumen:false,
            tabInicial: 'Resumen',
            totalLibros: 0,
            userAdmin:false,
            userFacturador:false,
            NohayStock:false,
            popupObservacion:false,
            busquedaxcodigo:'',
            tipoProceso:0,
            popupMostrarEmpresa:false,
            arrayEmpresas:[],
            empresa:null,
            mixinIdInicioFormatoNewData: null,
            //variables para aprovar sin stock
            ifAprobarSinStock:false,
            arrayGuiasSend:[],
            //fin variables para aprovar sin stock
            ifAprobarPendientes:0,
            ObjectPedidoHijo:'',
            //variables para anular pedido
            message_anulado:'',
            popupConfirmAnular:false,
            //fin variables para anular pedido
            //variables para imprimir documento perseo
            facturaDocumentoPerseo: null,
            popupDocumentoPerseo: false,
            //fin variables para imprimir documento perseo
            popupConfirmAprobar:false,
            //variables para filtro de fechas
            fechaInicio: '',
            fechaFin: '',
            pedidosOriginales: [], //para almacenar todos los pedidos sin filtro de fecha
            datosFiltradosPorFecha: false, // indica si pedidosOriginales tiene filtro de fecha aplicado
            //fin variables para filtro de fechas
          }
        },
        props: {
            pedidos: {
                type: Array,
                default: []
            },
            id_periodo: {
                type: Number,
                default: 0
            },
        },
        created() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem("usuario"))
        },
        watch: {
            pedidos(results) {
                let me = this;
                // Solo usar pedidos externos si los hay, sino obtener datos internamente
                if(results && results.length > 0){
                    me.pedidosOriginales = results; // Guardar todos los pedidos sin filtro
                    me.tmpPedidos = []
                    me.filtroTipo()
                }
            },
        },
        mounted() {
            let me = this;

            // Inicializar fechas: primer día del mes actual y hoy
            const hoy = new Date();
            const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
            me.fechaInicio = primerDiaMes.toISOString().substring(0, 10);
            me.fechaFin = hoy.toISOString().substring(0, 10);

            // Verifica si los datos existen en localStorage
            const mixinData = localStorage.getItem('mixin_IdInicioFormatoNew');
            if (mixinData) {
            // Convierte el JSON en un array de objetos y extrae solo 'minimo' si existe
            const parsedData = JSON.parse(mixinData);
            me.mixinIdInicioFormatoNewData = parsedData.length > 0 ? parsedData[0].minimo : null;
            console.log("Valor de minimo:", me.mixinIdInicioFormatoNewData); // Verifica el valor en consola
            } else {
                console.warn("No se encontraron datos en localStorage para mixin_IdInicioFormatoNew");
            }
            // FIN Verificación si los datos existen en localStorage

            // Determinar filtro inicial
            if(me.usuario.id_group == 27 || me.usuario.id_group == 17){
                me.filtro = 1
            }else{
                me.filtro = 0
            }

            // Obtener guias al montar el componente sin entregados (tipo del filtro inicial)
            me.getGuias(false, me.filtro).then(() => {
                // Aplicar filtro después de cargar datos
                me.filtroTipo();
            });

            //user admin
            if(me.usuario.id_group  == 22 || me.usuario.id_group == 23 || me.usuario.id_group == 1){
                me.userAdmin = true
            }
            //user facturador
            if(me.usuario.id_group  == 22 || me.usuario.id_group == 23){
                me.userFacturador = true
            }
        },
        computed: {
          ...mapState(['userRoot','userAsesor', 'userBodegaNormal','AdminBodega','groupFacturador']),
            sumaPendientes() {
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                //pendientes admin bodega
                var predatos = []
                predatos = source
                let datos = predatos.filter(p => (p.estado_entrega == 0) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAprobados() {
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => (p.estado_entrega == 1) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAprobadosPendientes() {
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => (p.estado_entrega == 3) && (p.estado == 1) && p.despachado_bodega == 0);
                let resultado = datos.length
                return resultado
            },
            SumaEntregados() {
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => ((p.estado_entrega == 2) || (p.despachado_bodega == 1)) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAnulados(){
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => (p.estado == 2));
                let resultado = datos.length
                return resultado
            },
            SumaSinEnviarPerseo(){
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => {
                    if(p.guias_version_perseo == 1 && p.pendientes && p.pendientes.length > 0){
                        return p.pendientes.some(hijo => hijo.estadoPerseo == 0 && hijo.est_ven_codigo != 3); // Solo contar como sin enviar si no está anulado
                    }
                    return false;
                });
                let resultado = datos.length
                return resultado
            },
            SumaEnviadosPerseo(){
                let me = this;
                const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
                let datos = source.filter(p => {
                    if(p.guias_version_perseo == 1 && p.pendientes && p.pendientes.length > 0){
                        return p.pendientes.some(hijo => hijo.estadoPerseo == 1 && hijo.est_ven_codigo != 3); // Solo contar como enviados si no está anulado
                    }
                    return false;
                });
                let resultado = datos.length
                return resultado
            }
        },
        methods: {
          //METODO PARA OBTENER GUIAS
          async getGuias(aplicarFiltroFecha = false, tipoFiltro = null) {
            let me = this;
            try {
                me.$vs.loading();

                // Construir URL con parámetros
                let url = me.$server_url + 'get_pedidos_guias?id_group=' + me.usuario.id_group;

                // Enviar tipo de filtro al backend
                if (tipoFiltro !== null) {
                    url += '&tipo_filtro=' + tipoFiltro;
                }

                // Solo aplicar filtro de fechas si se indica explícitamente
                if (aplicarFiltroFecha && me.fechaInicio && me.fechaFin) {
                    url += '&fecha_inicio=' + me.fechaInicio + '&fecha_fin=' + me.fechaFin;
                }

                const response = await me.$http.get(url);
                me.$vs.loading.close();

                let datos = response.data;

                // Filtrar por userRoot si no es root
                if(!me.userRoot){
                    datos = datos.filter(p => p.facturacion_vee == 1)
                }

                // Asignar datos según el grupo
                if (me.groupFacturador) {
                    me.pedidosOriginales = datos.filter(p => p.pedido_facturacion === 1);
                } else if (me.AdminBodega && !me.userBodegaNormal) {
                    me.pedidosOriginales = datos.filter(p => p.pedido_bodega === 1);
                } else if (me.userAsesor) {
                    me.pedidosOriginales = datos.filter(p => p.pedido_asesor === 1);
                } else {
                    me.pedidosOriginales = datos;
                }

                // Marcar si los datos están filtrados por fecha
                me.datosFiltradosPorFecha = aplicarFiltroFecha;

                // Aplicar filtro de tipo solo si no estamos en un flujo que ya lo aplicará
                // (para evitar loop infinito)
                // me.filtroTipo();

            } catch (error) {
                console.error("Error al obtener guías:", error);
                me.$vs.loading.close();
                me.$vs.notify({
                    text: 'Error al cargar las guías',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    time: 3000
                });
            }
          },
          //FIN METODO PARA ONTENER GUIAS
          openConfirmEmpresa(){
            let me = this
            me.$http.get(me.$server_url+'empresa')
            .then(function (res) {
                if(res.data.status == 0){
                    me.$vs.notify({
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle',
                        time:3000
                    })
                    return
                }
                me.arrayEmpresas       = res.data
                //remover el id 2
                me.arrayEmpresas       = me.arrayEmpresas.filter(p => p.id != 2)
                //si pedido.estado_entrega es mayor a 0 colocar el id empresa en el campo empresa
                if(me.pedido.estado_entrega > 0){
                    me.empresa = me.arrayEmpresas.find(p => p.id == me.pedido.empresa_id)
                }
                me.popupMostrarEmpresa = true
            })
          },
          verStock(){
              let me = this;
              me.arregloStock = []
              if(me.empresa == null || me.empresa == "" || me.empresa == undefined){
                  me.$vs.notify({
                      text: 'Seleccione una empresa',
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle',
                      time:3000
                  })
                  return
              }
              me.popupMostrarEmpresa = false
              me.$vs.loading()
              var url = ""
              //resumen para facturacion
              // if(me.tipoProceso == 0){
                  if(me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData){
                      var url = this.$server_url+'guias?verStock=yes&id_pedido='+me.pedido.id_pedido+'&empresa='+me.empresa.id
                  }else if(me.pedido.id_periodo > me.mixinIdInicioFormatoNewData){
                      var url = this.$server_url+'guias?verStock_new=yes&id_pedido='+me.pedido.id_pedido+'&empresa='+me.empresa.id
                  }
              //}
              // //resumen para bodega
              // if(me.tipoProceso == 1){
              //     if(me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData){
              //         url = this.$server_url+'guias?verStockGuiasProlipa=yes&id_pedido='+me.pedido.id_pedido+'&acta='+me.pedido.ven_codigo
              //     }else if(me.pedido.id_periodo > me.mixinIdInicioFormatoNewData){
              //         url = this.$server_url+'guias?verStockGuiasProlipa_new=yes&id_pedido='+me.pedido.id_pedido+'&acta='+me.pedido.ven_codigo
              //     }
              // }
              this.$http.get(url)
                  .then(function (res) {
                      me.$vs.loading.close()
                      if(res.data.status == 0){
                          me.$vs.notify({
                              text: res.data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-triangle',
                              time:3000
                          })
                          return
                      }
                      //ingresar libros en array
                      let datos = res.data
                      if(me.tipoProceso == 0){
                          //validate que haya stock
                          let validate = datos.filter(p => p.nuevoStock < 0)
                          if(validate.length > 0){
                              me.NohayStock = true
                          }else{
                              me.NohayStock = false
                          }
                          //fin validate que haya stock
                      }

                      var predatos = []
                      predatos = datos
                      me.arregloStock = predatos.sort(function(a, b) {
                          var nombreA = a.nombrelibro.toLowerCase();
                          var nombreB = b.nombrelibro.toLowerCase();
                          var numA = parseInt(nombreA.match(/\d+$/)); // extraer el número del final (si existe)
                          var numB = parseInt(nombreB.match(/\d+$/)); // extraer el número del final (si existe)
                          nombreA = nombreA.replace(/\d+$/, ''); // quitar el número del final
                          nombreB = nombreB.replace(/\d+$/, ''); // quitar el número del final

                          if (nombreA < nombreB) {
                              return -1;
                          }
                          if (nombreA > nombreB) {
                              return 1;
                          }
                          if (numA && !numB) { // si a tiene número y b no, b va primero
                              return 1;
                          }
                          if (!numA && numB) { // si b tiene número y a no, a va primero
                              return -1;
                          }
                          if (numA && numB) { // si ambos tienen número, compararlos
                              if (numA < 10 && numB >= 10) { // si a es menor que 10 y b es 10 o mayor, a va primero
                              return -1;
                              }
                              if (numA >= 10 && numB < 10) { // si b es menor que 10 y a es 10 o mayor, b va primero
                              return 1;
                              }
                              return numA - numB; // comparar los números directamente
                          }
                          return 0; // si son iguales en todo, no hay diferencia
                      });
                      //open confirm
                      //del arregloStock separar en un propiedad cantidad_descontar color el nuevoStock que  sea menor a 0
                      me.arregloStock.forEach(item => {
                          item.cantidadAutorizar = 0
                          if(item.nuevoStock < 0){
                              item.cantidad_descontar = Math.abs(item.nuevoStock)
                          }else{
                              item.cantidad_descontar = 0
                          }
                      })
                      me.popupConfirmAprobar = true
                  })
                  .catch(function (error) {
                      console.log(error + ' error');
                      me.$vs.loading.close()
                      me.$vs.notify({
                          text: "Ocurrio un error al cargar los datos",
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-triangle',
                          time:3000
                      })
                  })

          },
          enviarGuiasBDMilton(){
              let me = this
              let nuevarutaxperiodo = '';
              //validacion
              if(me.pedido.codigo_contrato == null || me.pedido.codigo_contrato == "" || me.pedido.codigo_contrato == undefined || me.pedido.iniciales == "" || me.pedido.iniciales == null || me.pedido.iniciales == "null"){
                  me.$vs.notify({
                      text: 'El codigo del periodo o las iniciales del asesor no estan configuradas',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  return
              }
              if(me.usuario.iniciales == null || me.usuario.iniciales == "null" || me.usuario.iniciales == "" || me.usuario.iniciales == undefined){
                  me.$vs.notify({
                      text: 'El codigo del usuario facturador no esta configurado',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  return
              }
              let formData = new FormData();
              formData.append('id_pedido',            me.pedido.id_pedido)
              formData.append('codigo_contrato',      me.pedido.codigo_contrato)
              formData.append('iniciales',            me.pedido.iniciales);
              formData.append('usuario_fact',         me.usuario.idusuario)
              formData.append('codigo_usuario_fact',  me.usuario.iniciales);
              formData.append('region_idregion',      me.pedido.region_idregion)
              formData.append('asesor_id',            me.pedido.id_asesor)
              formData.append('id_periodo',           me.pedido.id_periodo)
              formData.append('empresa_id',           me.empresa.id)
              formData.append('guias_send',           JSON.stringify(me.arrayGuiasSend))
              formData.append('ifAprobarSinStock',    me.ifAprobarSinStock)
              formData.append('ifAprobarPendientes',  me.ifAprobarPendientes)
              if(me.ifAprobarPendientes == '1'){
                formData.append('ven_codigoPadre',me.pedido.ven_codigo)
              }
              if (me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData) {
                formData.append('ifnuevo',            0)

              }else if (me.pedido.id_periodo > me.mixinIdInicioFormatoNewData) {
                formData.append('ifnuevo',            1)

              }
              me.$vs.loading()
              for (let [key, value] of formData.entries()) {
                  console.log(`${key}: ${value}`);
              }
                if(me.ifAprobarPendientes == '1'){
                    formData.append('guardarGuiasPendientes',1)
                    nuevarutaxperiodo = 'guias';
                }else{
                    nuevarutaxperiodo = 'guardarGuiasBDMilton_new';
                }
              this.$http.post(this.$server_url+nuevarutaxperiodo, formData)
              .then(function (res) {
                  me.$vs.loading.close()
                  if(res.data.status == 0){
                      me.$vs.notify({
                          text: res.data.message,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-triangle',
                          time:3000
                      })
                      return
                  }
                  me.$vs.notify({
                      text: 'Se guardo correctamente',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  me.popupGenerarDocumento = false;
                  me.popupMostrarEmpresa = false;
                  me.ifAprobarPendientes = 0
                  me.arrayGuiasSend      = []
                  me.ifAprobarSinStock   = 0
                  me.$emit('changeRecarge', true)
              })
              .catch(function (error) {
                  me.$vs.loading.close();
                  // Manejo de errores HTTP 500 y otros errores
                  let errorMessage = 'Error desconocido';
                  if (error.response && error.response.data && error.response.data.message) {
                      errorMessage = error.response.data.message;
                  }
                  me.$vs.notify({
                      text: errorMessage,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  });
              });
          },
          changeHandle(e) {
              let me                                  = this;
              me.popupCarga                           = false
              me.mostrarReporteG                      = false
              me.mostrarImprimirActa                  = false
              me.mostrarImprimirActaBodega            = false
              me.mostrarImprimirActaBodegaPendientes  = false
              me.pedido                               = {}
              me.ObjectPedidoHijo                     = { }
          },
          ver_pedido(item) {
              let me = this;
              localStorage.setItem("id_periodo_selected", item.id_periodo)
              localStorage.setItem("nombre_periodo_selected", item.periodo)
              this.$store.dispatch('setGuia',item)
              this.$emit('showPedido',1)
          },
          getReporteGuia(tr) {
              let me = this;
              localStorage.setItem("id_periodo_selected", tr.id_periodo)
              localStorage.setItem("nombre_periodo_selected", tr.periodo)
              me.id_pedido = tr.id_pedido
              // me.popupCarga = true
              me.mostrarReporteG = true
          },
          ImprimirActa(tipo){
              let me                              = this;
              // me.popupCarga                       = true
              if(tipo == 0){
                  me.mostrarImprimirActa          = true
              }
              if(tipo == 1){
                  me.mostrarImprimirActaBodega    = true
              }

          },
          f_mostrarDocumentoPendiente(){
            let me = this
            me.mostrarImprimirActaBodegaPendientes = true
          },
          confirma_delete_pedido(item) {
              let me = this;
              me.pedidoGuiaEliminar = item;
              me.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: 'Confirmar',
                  text: 'Seguro desea eliminar este pedido?. No lo podrá recuperar',
                  acceptText: 'Aceptar',
                  cancelText: 'Cancelar',
                  accept: me.f_eliminarGuiaPedido
              })
          },
          f_eliminarGuiaPedido() {
              let me = this;
              let rutaperiodofinal = '';
              if (me.pedidoGuiaEliminar.id_periodo <= me.mixinIdInicioFormatoNewData) {
                  rutaperiodofinal = 'deletePedidoGuia/';
              }else if(me.pedidoGuiaEliminar.id_periodo > me.mixinIdInicioFormatoNewData){
                  rutaperiodofinal = 'deletePedidoGuia_new/';
              }
              this.$http.get(this.$server_url + rutaperiodofinal + me.pedidoGuiaEliminar.id_pedido)
                  .then((result) => {
                      console.log(result.data)
                      me.$vs.notify({
                          color: 'danger',
                          text: 'Pedido eliminado correctamente'
                      })
                      me.$emit('changeRecarge', true)
                  }).catch((err) => {
                      console.log(err)
                  });
          },
          async filtroTipo(dato) {
              let me = this;
              me.tmpPedidos = []

              // Si es filtro 3 (Entregados), cargar datos con filtro de fecha y tipo 3
              if (me.filtro == 3) {
                  if (!me.datosFiltradosPorFecha) {
                      await me.getGuias(true, 3);
                  }
                  // No hacer return, continuar para aplicar el filtro
              }
              // Para los demás filtros, cargar datos sin entregados (excluir estado_entrega=2)
              else if (me.filtro != 3) {
                  if (me.datosFiltradosPorFecha || me.pedidosOriginales.length === 0) {
                      await me.getGuias(false, me.filtro);
                  }
              }

              // Usar pedidosOriginales en lugar de pedidos
              const source = me.pedidosOriginales.length > 0 ? me.pedidosOriginales : me.pedidos;
              //para ver los pedidos pendientes
              if (me.filtro == 0) {
                  //bodega mostrar los pedidos pendientes de bodega
                  var predatos = []
                  predatos = source
                  let datos = predatos.filter(p => (p.estado_entrega == 0 && p.estado == 1));
                  me.tmpPedidos = datos
                  return
              }
              //para ver los pedidos aprobados
              else if (me.filtro == 1) {
                  let datos = source.filter(p => (p.estado_entrega == 1) && p.estado == 1);
                  me.tmpPedidos = datos
                  return
              }
              //para ver los pedidos pendientes
              else if (me.filtro == 2) {
                  let datos = source.filter(p => (p.estado_entrega == 3) && p.estado == 1 && p.despachado_bodega == 0);
                  me.tmpPedidos = datos
                  return
              }
              // entregados por bodega
              else if(me.filtro == 3){
                if(dato){
                    let datos = source.filter(guias => {
                          return ((guias.estado_entrega == 2 || guias.despachado_bodega == 1) && guias.estado == 1) && guias.ven_codigo.toString().toUpperCase().includes(dato.toUpperCase());
                    });
                    me.tmpPedidos = datos;
                    return;
                }else{
                    let datos = source.filter(g => ((g.estado_entrega == 2 || g.despachado_bodega == 1) && g.estado == 1));
                    me.tmpPedidos = datos;
                    return;
                }
              }
              // anulados por facturacion
              else if(me.filtro == 4){
                var predatos = []
                predatos = source
                let datos = predatos.filter(p => (p.estado == 2));
                me.tmpPedidos = datos
                return
              }
              // sin enviar a perseo
              else if(me.filtro == 5){
                let datos = source.filter(p => {
                    if(p.guias_version_perseo == 1 && p.pendientes && p.pendientes.length > 0){
                        return p.pendientes.some(hijo => hijo.estadoPerseo == 0  && hijo.est_ven_codigo != 3); // Solo contar como sin enviar si no está anulado
                    }
                    return false;
                });
                me.tmpPedidos = datos
                return
              }
              // enviados a perseo
              else if(me.filtro == 6){
                let datos = source.filter(p => {
                    if(p.guias_version_perseo == 1 && p.pendientes && p.pendientes.length > 0){
                        return p.pendientes.some(hijo => hijo.estadoPerseo == 1 && hijo.est_ven_codigo != 3); // Solo contar como enviados si no está anulado
                    }
                    return false;
                });
                me.tmpPedidos = datos
                return
              }
          },
          filtrarPedidos() {
              let me = this;
              const busqueda = this.busquedaxcodigo.toUpperCase();
              if (busqueda.length > 0 && this.filtro == 3) {
                  this.filtroTipo(busqueda);
              }else{
                  this.filtroTipo(busqueda);
                      me.$vs.notify({
                      text: 'No tiene datos de',
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
              }
          },
          verificarTodosEnviadosPerseo(pedido) {
              if(pedido.guias_version_perseo === 1 && pedido.pendientes && pedido.pendientes.length > 0) {
                  return pedido.pendientes.every(hijo => hijo.estadoPerseo === 1);
              }
              return false;
          },
          //====METODOS DE BODEGA======
          openConfirm(){
              this.$vs.dialog({
                  type:'confirm',
                  color: 'danger',
                  title: `Confirmar`,
                  acceptText:'aceptar',
                  cancelText:'cancelar',
                  text: 'Esta seguro de entregar esta solicitud de guias?',
                  accept:this.entregarPedido
              })
          },
          entregarPedido() {
              let me = this
              me.$vs.loading();
              let data = {
                  'id_pedido': this.pedido.id_pedido,
                  'estado': '2',
                  'grupo': 'bodega',
                  'acta':this.pedido.ven_codigo,
                  'asesor_id':this.pedido.id_asesor
              }
              this.$http.post(this.$server_url + 'entregarPedido', data)
                  .then(res => {
                      me.f_notificaciones('Pedido entregado', 'success', 'check')
                      me.$emit('changeRecarge', true)
                      me.$vs.loading.close();
                  })
                  .catch(err => {
                      console.log(err)
                      me.$vs.loading.close();
                  })
          },
          f_notificaciones(msj, color, icono) {
              let me = this;
              me.$vs.notify({
                  text: msj,
                  color: color,
                  iconPack: 'feather',
                  icon: icono
              })
              return;
          },
          //====FIN METODOS DE BODEGA====
          //METODOS PARA APROBAR SIN STOCK
          changeAprobar(e,guiasSend=[]){
              let me = this
              me.arrayGuiasSend     = []
              me.ifAprobarSinStock  = e
              me.arrayGuiasSend     = guiasSend
            //   me.verStock()
          },
          changeAprobarPendientes(e){
            let me = this
            me.arrayGuiasSend     = []
            me.arrayGuiasSend     = e
            me.popupGenerarDocumento = false
            me.f_confirmarAprobarPendientes()
          },
          f_confirmarAprobarPendientes(){
            let me = this
            me.ifAprobarPendientes = 1
            this.$vs.dialog({
              type:'confirm',
              color: 'danger',
              title: `Confirm`,
              text: `¿Estás seguro de aprobar las guias pendientes de ${this.arrayGuiasSend.length} libros?`,
              accept:this.enviarGuiasBDMilton,
              acceptText:'Aceptar',
              cancelText:'Cancelar',
              cancel: () => {
                me.popupGenerarDocumento = true;
              }
            })
          },
          //METODOS PARA ANULAR PEDIDO
          anularPedido() {
            let me = this
            //quitar espacios
            me.message_anulado = me.message_anulado.trim();
            if(me.message_anulado == ''){
                me.m_message('Escribe un mensaje porque se anuló el pedido', 'danger', 'alert-triangle')
                return
            }

            me.$vs.loading();
            let formData = new FormData();
            formData.append('anularPedidoAprobado', 1)
            formData.append('id_pedido',            me.pedido.id_pedido)
            formData.append('user_created',         me.usuario.idusuario)
            formData.append('message_anulado',      me.message_anulado)
            if (me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData) {
            formData.append('ifnuevo',            0)

            }else if (me.pedido.id_periodo > me.mixinIdInicioFormatoNewData) {
            formData.append('ifnuevo',            1)

            }
            this.$http.post(this.$server_url + 'guias', formData)
            .then(res => {
                me.$vs.loading.close();
                if(res.data.status == 0){
                    me.m_message(res.data.message, 'danger', 'alert-triangle')
                    return
                }
                me.m_message(res.data.message, 'success', 'check')
                me.popupConfirmAnular = false;
                me.message_anulado = '';
                me.$emit('changeRecarge', true)
            })
            .catch(err => {
            console.log(err)
            me.$vs.loading.close();
            })
          },
          abrirDocumentoPerseo(p, tr) {
            let me = this;
            me.$vs.loading();
            me.$http.get(me.$server_url + 'guias?listadoDocumentoVentaGuias=1&id_pedido=' + tr.id_pedido)
            .then((res) => {
                me.$vs.loading.close();
                let documento = res.data.find(d => d.ven_codigo === p.ven_codigo);
                if (documento) {
                    me.facturaDocumentoPerseo = documento;
                    me.popupDocumentoPerseo = true;
                } else {
                    me.$vs.notify({
                        text: 'Documento no encontrado',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle',
                        time: 3000
                    });
                }
            })
            .catch((err) => {
                me.$vs.loading.close();
                console.error(err);
                me.$vs.notify({
                    text: 'Error al cargar el documento',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    time: 3000
                });
            });
          },
          //METODOS PARA FILTRO DE FECHAS
          filtrarPorFechas() {
            let me = this;
            if (!me.fechaInicio || !me.fechaFin) {
                me.$vs.notify({
                    text: 'Por favor, seleccione ambas fechas',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    time: 3000
                });
                return;
            }

            // Validar que fecha inicio sea menor o igual a fecha fin
            if (new Date(me.fechaInicio) > new Date(me.fechaFin)) {
                me.$vs.notify({
                    text: 'La fecha de inicio debe ser menor o igual a la fecha fin',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    time: 3000
                });
                return;
            }

            // Aplicar filtro de fechas solo para el filtro de entregados (tipo 3)
            me.getGuias(true, 3).then(() => {
                me.filtroTipo();
            });

            me.$vs.notify({
                text: 'Filtro de fechas aplicado correctamente',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check',
                time: 2000
            });
          },
          limpiarFiltroFechas() {
            let me = this;
            // Resetear fechas a valores predeterminados
            const hoy = new Date();
            const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
            me.fechaInicio = primerDiaMes.toISOString().substring(0, 10);
            me.fechaFin = hoy.toISOString().substring(0, 10);

            // Recargar datos con el filtro de fecha usando las nuevas fechas (primer día del mes a hoy)
            me.getGuias(true, 3).then(() => {
                me.filtroTipo();
            });

            me.$vs.notify({
                text: 'Filtro de fechas restablecido a valores por defecto',
                color: 'primary',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                time: 2000
            });
          },
          //FIN METODOS PARA FILTRO DE FECHAS
          //METODO PARA RECARGAR GUIAS AL CERRAR MODAL
          recargarGuias() {
            let me = this;
            me.getGuias(false, me.filtro).then(() => {
              me.filtroTipo();
            });
          }
          //FIN METODO PARA RECARGAR GUIAS AL CERRAR MODAL
        }
    }
    </script>
    <style scoped>
    .popupPadre {
        z-index: 51001;
    }
    </style>
